export const EXISTING_ACCOUNTS = [
  {
    accountNumber: "123456",
    fullName: "Aisha Rahman",
    email: "aisha.rahman@example.com",
    phone: "+971 50 123 4567",
    countryOfResidence: "United Arab Emirates",
    kycApproved: true,
  },
  {
    accountNumber: "100001",
    fullName: "James Okonkwo",
    email: "james.okonkwo@example.com",
    phone: "+971 55 221 8890",
    countryOfResidence: "Nigeria",
    kycApproved: true,
  },
  {
    accountNumber: "654321",
    fullName: "Priya Sharma",
    email: "priya.sharma@example.com",
    phone: "+971 52 447 1193",
    countryOfResidence: "India",
    kycApproved: false,
  },
  {
    accountNumber: "100002",
    fullName: "Omar Haddad",
    email: "omar.haddad@example.com",
    phone: "+971 56 774 3301",
    countryOfResidence: "Jordan",
    kycApproved: false,
  },
];
